import { Exception } from '@core/exceptions/exception';

export class PasswordResetException extends Exception {
  constructor(message = 'Password reset exception.') {
    super(message);
  }
}
